import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import useAuthStore from './store/authStore';
import Layout from './components/Layout';

const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Pousada = lazy(() => import('./pages/Pousada'));
const Restaurante = lazy(() => import('./pages/Restaurante'));
const Estoque = lazy(() => import('./pages/Estoque'));
const Financeiro = lazy(() => import('./pages/Financeiro'));
const Usuarios = lazy(() => import('./pages/Usuarios'));
const Relatorios = lazy(() => import('./pages/Relatorios'));
const Caixa = lazy(() => import('./pages/Caixa'));
const Delivery = lazy(() => import('./pages/Delivery'));
const CardapioOnline = lazy(() => import('./pages/CardapioOnline'));
const Cozinha = lazy(() => import('./pages/restaurante/Cozinha'));
const Configuracoes = lazy(() => import('./pages/Configuracoes'));
const Escala = lazy(() => import('./pages/Escala'));
const Clientes = lazy(() => import('./pages/Clientes'));
const Setup = lazy(() => import('./pages/Setup'));
const RedefinirSenha = lazy(() => import('./pages/RedefinirSenha'));
const AdminUnibox = lazy(() => import('./pages/AdminUnibox'));

function RotaProtegida({ children }) {
  const usuario = useAuthStore((state) => state.usuario);
  return usuario ? children : <Navigate to="/login" replace />;
}

function RotaOperacional({ children }) {
  if (window.location.hostname === 'admin.unibox.app.br') {
    return <Navigate to="/admin-unibox" replace />;
  }
  return children;
}

function rotaInicial(cargo) {
  return {
    recepcionista: '/pousada',
    garcom: '/restaurante',
    cozinheiro: '/cozinha',
    caixa: '/caixa',
    entregador: '/delivery',
  }[cargo] || '/';
}

function RotaCargo({ cargos, children }) {
  const usuario = useAuthStore((state) => state.usuario);
  return cargos.includes(usuario?.cargo) ? children : <Navigate to={rotaInicial(usuario?.cargo)} replace />;
}

export default function App() {
  return (
    <ConfigProvider locale={ptBR}>
      <BrowserRouter>
        <Suspense fallback={<div style={{ padding: 24 }}>Carregando...</div>}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/admin-unibox" element={<RotaProtegida><RotaCargo cargos={['admin']}><AdminUnibox /></RotaCargo></RotaProtegida>} />
          <Route path="/cardapio-publico" element={<Navigate to="/pedido" replace />} />
          <Route path="/pedido" element={<CardapioOnline />} />
          <Route
            path="/"
            element={
              <RotaProtegida>
                <RotaOperacional><Layout /></RotaOperacional>
              </RotaProtegida>
            }
          >
            <Route index element={<RotaCargo cargos={['admin', 'gerente']}><Dashboard /></RotaCargo>} />
            <Route path="pousada" element={<RotaCargo cargos={['admin', 'gerente', 'recepcionista']}><Pousada /></RotaCargo>} />
            <Route path="restaurante" element={<RotaCargo cargos={['admin', 'gerente', 'garcom', 'recepcionista', 'caixa']}><Restaurante /></RotaCargo>} />
            <Route path="cozinha" element={<RotaCargo cargos={['admin', 'gerente', 'cozinheiro', 'caixa']}><Cozinha /></RotaCargo>} />
            <Route path="estoque" element={<RotaCargo cargos={['admin', 'gerente']}><Estoque /></RotaCargo>} />
            <Route path="financeiro" element={<RotaCargo cargos={['admin', 'gerente']}><Financeiro /></RotaCargo>} />
            <Route path="caixa" element={<RotaCargo cargos={['admin', 'gerente', 'caixa']}><Caixa /></RotaCargo>} />
            <Route path="relatorios" element={<RotaCargo cargos={['admin', 'gerente']}><Relatorios /></RotaCargo>} />
            <Route path="delivery" element={<RotaCargo cargos={['admin', 'gerente', 'caixa', 'entregador']}><Delivery /></RotaCargo>} />
            <Route path="usuarios" element={<RotaCargo cargos={['admin', 'gerente']}><Usuarios /></RotaCargo>} />
            <Route path="configuracoes" element={<RotaCargo cargos={['admin', 'gerente']}><Configuracoes /></RotaCargo>} />
            <Route path="escala" element={<RotaCargo cargos={['admin', 'gerente']}><Escala /></RotaCargo>} />
            <Route path="clientes" element={<RotaCargo cargos={['admin', 'gerente', 'caixa']}><Clientes /></RotaCargo>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </ConfigProvider>
  );
}
